/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Gateway_CountInputs */



/**
* | countPlural | output |
* | --- | --- |
* | "one" | "gateway" |
* | "other" | "gateways" |
*
* @param {Gateway_CountInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const gateway_count = /** @type {((inputs: Gateway_CountInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_CountInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		const countPlural = registry.plural("en", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`gateway`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`gateways`);
		return /** @type {LocalizedString} */ ("gateway_count");
	}
	{
		const countPlural = registry.plural("fr", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`box`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`box`);
		return /** @type {LocalizedString} */ ("gateway_count");
	}
});